// Build-time feature flags. Plain consts so the bundler can tree-shake the
// gated UI out entirely when one is off.

// Deep (AI meaning-impact) analysis. Parked: the premium pass classifies every
// flag by how much it changes MEANING, but "meaning changed" isn't the same
// question as "worth a pickup" — it over-flags and didn't earn its cost. Hidden
// for now (no trigger, no chips, no per-flag rating) while we rethink review
// prioritisation. Flip to true to bring the whole feature back unchanged; the
// backend job + data model are untouched.
export const SHOW_MEANING_ANALYSIS = false;
